import { render } from "./Splash.vue?vue&type=template&id=2614e018&scoped=true&ts=true"
import script from "./Splash.vue?vue&type=script&lang=ts"
export * from "./Splash.vue?vue&type=script&lang=ts"

import "./Splash.vue?vue&type=style&index=0&id=2614e018&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2614e018"]])

export default __exports__